import { render, staticRenderFns } from "./TipsView.vue?vue&type=template&id=5c1d2bfc&"
import script from "./TipsView.vue?vue&type=script&lang=ts&"
export * from "./TipsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports